import { FC } from 'react'

import { QuantityInput } from '@syconium/little-miss-figgy'

import { trackEvent } from '../../../../../lib/analytics'
import { bulkOrderCategory } from '../../constants'

type Props = {
  productId: string
  quantity: number | undefined
  incrementQuantity: () => void
  decrementQuantity: () => void
  onQuantityChange(value: number | undefined): void
  disabled?: boolean
}

export const BulkQuantity: FC<Props> = ({
  productId,
  quantity,
  incrementQuantity,
  decrementQuantity,
  onQuantityChange,
  disabled = false,
}) => {
  const handleInputChange = (qty: number | undefined) => {
    onQuantityChange(qty)
  }

  return (
    <QuantityInput.Wrapper id={`bulk-input-${productId}`} disabled={disabled}>
      <QuantityInput.Control
        decrement
        onClick={decrementQuantity}
        disabled={!quantity || quantity === 1 || disabled}
        {...trackEvent({
          category: bulkOrderCategory,
          action: 'decrement bulk item',
          value: quantity ? quantity - 1 : 1,
        })}
      />
      <QuantityInput.Input
        fullWidth
        value={quantity}
        disabled={disabled}
        onChange={handleInputChange}
        min={0}
        {...trackEvent({
          category: bulkOrderCategory,
          action: 'modify bulk item quantity',
          value: quantity,
        })}
      />
      <QuantityInput.Control
        increment
        onClick={incrementQuantity}
        disabled={disabled}
        {...trackEvent({
          category: bulkOrderCategory,
          action: 'increment bulk item',
          value: quantity ? quantity + 1 : 1,
        })}
      />
    </QuantityInput.Wrapper>
  )
}
